import { defaultEmergencyContacts } from '../../../types';
import uuidv4 from 'uuid-browser/v4';
import { saveApplication, debounce } from './../../../utilities';
import { DEBOUNCE_TIME } from './../../../constants';
import validate from '../../../validations';

export default {
    refreshOn: ({ emergencyContacts }) => [ emergencyContacts ],
    init: (fullState, stateManager, internalStateSetter) => {
        debounce(() => saveApplication(stateManager), DEBOUNCE_TIME)
    },
    'EmergencyContact.Wrapper.ContactsList': ({ emergencyContacts}, stateManager) => {
        stateManager.setEmergencyContacts(emergencyContacts)
        validate(300)
    },
    'EmergencyContact.Wrapper.AddContact': ({ emergencyContacts }, stateManager) => {
        const newContacts = {...defaultEmergencyContacts}
        newContacts.id = uuidv4()

        stateManager.setEmergencyContacts([...emergencyContacts, newContacts])
        debounce(() => saveApplication(stateManager), DEBOUNCE_TIME)
    },
};
